var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddBlankPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5505 25.125H8.05054C6.57397 25.125 5.42554 23.9766 5.42554 22.5V6.75C5.42554 5.31445 6.57397 4.125 8.05054 4.125H15.4744C16.1716 4.125 16.8279 4.41211 17.3201 4.9043L20.3962 7.98047C20.8884 8.47266 21.1755 9.12891 21.1755 9.82617V22.5C21.1755 23.9766 19.9861 25.125 18.5505 25.125ZM8.05054 23.1562H18.5505C18.8787 23.1562 19.2068 22.8691 19.2068 22.5V9.82617C19.2068 9.66211 19.1248 9.49805 19.0017 9.375L15.9255 6.29883C15.8025 6.17578 15.6384 6.09375 15.4744 6.09375H8.05054C7.6814 6.09375 7.39429 6.42188 7.39429 6.75V22.5C7.39429 22.8691 7.6814 23.1562 8.05054 23.1562Z",
    fill: "#465DD8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1609,
    cy: 24.2999,
    r: 4.19983,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4005 23.801C15.4005 20.4964 18.0723 17.8012 21.4003 17.8012C24.7048 17.8012 27.4 20.4964 27.4 23.801C27.4 27.129 24.7048 29.8007 21.4003 29.8007C18.0723 29.8007 15.4005 27.129 15.4005 23.801ZM21.4003 26.4259C21.7049 26.4259 21.9627 26.1915 21.9627 25.8634V24.3634H23.4627C23.7674 24.3634 24.0252 24.1291 24.0252 23.801C24.0252 23.4963 23.7674 23.2385 23.4627 23.2385H21.9627V21.7385C21.9627 21.4339 21.7049 21.1761 21.4003 21.1761C21.0722 21.1761 20.8378 21.4339 20.8378 21.7385V23.2385H19.3379C19.0097 23.2385 18.7754 23.4963 18.7754 23.801C18.7754 24.1291 19.0097 24.3634 19.3379 24.3634H20.8378V25.8634C20.8378 26.1915 21.0722 26.4259 21.4003 26.4259Z",
    fill: "#465DD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlankPage);
export default __webpack_public_path__ + "static/media/AddBlankPage.2e68ad12.svg";
export { ForwardRef as ReactComponent };